angular.module('wbDirectives').directive('wbAutofocus', ['$timeout', ($timeout) => {
  return {
    restrict: 'A',
    link : function($scope, $element) {
      $timeout(function() {
        $element[0].focus();
      });
    }
  }
}]);
